"use client";

import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbCard } from "@storyblok/types/287435740670216/storyblok-components";
import { RichTextRenderer } from "../shared/storyblok-rich-text-renderer";

type CardProperties = {
  blok: SbCard;
  pageData: { locale: string };
};

export function CardComponent({ blok, pageData }: CardProperties) {
  return (
    <article
      {...storyblokEditable(blok as SbBlokData)}
      className="flex h-full flex-col rounded-3xl p-6 sm:p-8"
      style={{
        backgroundColor: `var(--${blok.backgroundColor})`,
      }}
    >
      <h3
        className="font-heading text-2xl font-extrabold tracking-wide uppercase sm:text-3xl"
        style={{
          color: `var(--${blok.titleColor})`,
        }}
      >
        {blok.title}
      </h3>

      <div
        className="mt-4 flex-1 text-base leading-relaxed sm:mt-6"
        style={{
          color: `var(--${blok.textColor})`,
        }}
      >
        <RichTextRenderer document={blok.content} pageData={pageData} />
      </div>
    </article>
  );
}
